function Navbar(){
    return(
        <div>
            <h1 style={{
                color:'red',
                backgroundColor:'black',
                paddingLeft:'0.9rem',
                paddingTop:'1.2rem',
                paddingBottom:'1rem'
                }}>Movie Trailer App</h1>
        </div>
    )
}
export default Navbar;
